import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from "../assets/ioof-logo.png";

export default function Navbar() {
    const location = useLocation();

    const isHome = location.pathname === '/';
    const isMembership = location.pathname === '/membership';
    const isCalendar = location.pathname === '/calendar';

    const navLinks = [
        { to: "/", label: "Home", isCurrentPage: isHome },
        { to: "/membership", label: "Membership", isCurrentPage: isMembership },
        { to: "/calendar", label: "Calendar", isCurrentPage: isCalendar },
    ];

    const filteredLinks = navLinks.filter(link => !link.isCurrentPage);

    const navbarStyle = {
        backgroundColor: "#012F47",
        color: "white",
        padding: "6px 6px",
        textAlign: "left",
        fontSize: "14px",
        fontWeight: "bold",
        width: "100%"
    }

    return (
        <div className="navbar bg-neutral fixed top-0 z-50" style={navbarStyle}>
            <div className="flex-1">
                <Link to="/" className="btn p-0 bg-[#012F47] border-[#012F47] hover:bg-[#D5BD5D]">
                    <img src={Logo} className="h-10"
                    alt="The international order of odd fellows logo: 
                    three chain links with the letters F L T for Friendship, Love and Truth. 
                    The first chain is white, second is blue and third is red." />
                </Link>
            </div>

            {/* Desktop nav - hidden on mobile */}
            <div className="hidden sm:flex flex-none">
                <ul className="menu menu-horizontal gap-4 p-0 font-heading">
                    {filteredLinks.map(link => (
                        <li key={link.to}>
                            <Link
                                to={link.to}
                                className="btn font-bold font-heading bg-[#012F47] border-[#012F47] hover:bg-[#631F07] text-white"
                            >
                                {link.label}
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>

            {/* Mobile hamburger - hidden on desktop */}
            <div className="sm:hidden dropdown dropdown-end">
                <label tabIndex={0} className="btn bg-[#012F47] border-[#012F47] hover:bg-[#631F07] text-white">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                    </svg>
                </label>
                <ul tabIndex={0} className="dropdown-content menu p-2 shadow bg-[#012F47] rounded-box w-40 mt-2">
                    {filteredLinks.map(link => (
                        <li key={link.to}>
                            <Link
                                to={link.to}
                                className="font-bold font-heading text-white hover:bg-[#631F07]"
                            >
                                {link.label}
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}